import { render } from "./ImpersonateLogin.vue?vue&type=template&id=c2529c10"
import script from "./ImpersonateLogin.vue?vue&type=script&lang=js"
export * from "./ImpersonateLogin.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__